<template>
    <div class="chatbot-embed">
      <Chatbot v-if="isChatOpen" @close="toggleChatbot" />
      <div v-if="!isChatOpen" class="chat-toggle-btn chatbot" @click.stop="toggleChatbot">
        <img
            :src="require('@/assets/images/chat.svg')"
            class="icon"
        />
      </div>
    </div>
</template>

<script>
import Chatbot from '@/components/Chatbot'
import { mapMutations } from 'vuex'

export default {
  name: 'ChatbotEmbed',
  components: { Chatbot },
  data() {
    return {
      isChatOpen: false
    }
  },
  mounted() {
    this.setShowChatbotHeader(true)
    window.parent.postMessage('chatWidgetRendered', '*')

    if (this.$route.query.openChat === 'true' && !this.isChatOpen) {
      this.isChatOpen = true
    } else if (this.$route.query.openChat === 'false' && this.isChatOpen) {
      this.isChatOpen = false
    }
  },
  methods: {
    ...mapMutations(['setShowChatbotHeader']),
    toggleChatbot() {
      if (this.isTransitioning) return

      this.isTransitioning = true
      const newChatState = !this.isChatOpen
      const timeoutDuration = newChatState ? 0 : 300

      setTimeout(() => {
        this.isChatOpen = newChatState
        this.isTransitioning = false
      }, timeoutDuration)

      const message = newChatState ? 'chatWidgetOpened' : 'chatWidgetClosed'
      window.parent.postMessage(message, '*')
    }
  }
}
</script>

<style scoped lang="less">
  .chat-toggle-btn {
    position: absolute;
    bottom: 0px;
    right: 0px;
    background: var(--theme_color);
    border-radius: 50%;
    padding: 10px;
    cursor: pointer;
  }

  .icon {
    width: 30px;
    height: 30px;
  }
</style>

<style>
  body {
    background: transparent !important;
  }
</style>
